import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TicketService } from 'app/core/services/ticket.service';

@Component({
  selector: 'dialog-add-ticket',
  templateUrl: './dialog-add-ticket.component.html',
  styleUrls: ['./dialog-add-ticket.component.scss']
})
export class DialogAddTicketComponent implements OnInit {
  isLoading: boolean = false;
  ticketForm: FormGroup;
  type: any [] = [];

  constructor(public dialogRef: MatDialogRef<DialogAddTicketComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private ticketService: TicketService) {
    this.ticketForm = this.fb.group({
      category: [null, Validators.required],
      subject: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getRequestType();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getRequestType() {
    this.ticketService.getRequestType().subscribe({
      next: res => {
        this.type = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }
  
  save() {
    this.isLoading = true;
    this.ticketService.createTicket(this.ticketForm.value).subscribe({
      next: res => {
        this.dialogRef.close();
        window.location.reload();
      },
      error: err => {
        this.isLoading = false;
      }
    })
  }
}
